import { DeliveryCompany } from 'src/admin-entity/interface/delivery/delivery-company.interface';

export interface DeliveryCompanyInitState {
    deliveryCompanyList: DeliveryCompany[];
}

export const initialState: DeliveryCompanyInitState = {
    deliveryCompanyList: [],
};
